import { gql } from "@apollo/client";

export const ADD_RUN_COMMENT = gql`
  mutation AddRunComment($stackId: ID!, $runId: ID!, $body: String!) {
    runComment(stack: $stackId, run: $runId, body: $body) {
      createdAt
    }
  }
`;
